<script setup lang="ts">
import { Markdown } from '@comark/vue'
import highlight from '@comark/vue/plugins/highlight'
import security from '@comark/vue/plugins/security'
import githubDark from '@shikijs/themes/github-dark'
import githubLight from '@shikijs/themes/github-light'
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  markdown?: string | null
  emptyText?: string
}>(), {
  markdown: null,
  emptyText: 'No changelog yet.',
})

const plugins = [
  security({
    blockedTags: [
      'script',
      'style',
      'iframe',
      'object',
      'embed',
      'form',
      'input',
      'button',
      'link',
      'meta',
      'base',
    ],
    allowedProtocols: ['http', 'https', 'mailto'],
  }),
  highlight({ themes: { light: githubLight, dark: githubDark } }),
]

const hasContent = computed(() => Boolean(props.markdown && props.markdown.trim()))
</script>

<template>
  <div v-if="hasContent" class="text-default text-sm">
    <Suspense>
      <Markdown :value="markdown ?? ''" :plugins="plugins" />
    </Suspense>
  </div>
  <p v-else class="text-muted text-sm">
    {{ emptyText }}
  </p>
</template>
